import React, { createElement, useCallback, useEffect } from 'react';
import { useLocalObservable, observer } from 'mobx-react';
import { apiStore } from '@/store';
import { ApiMap, idList } from '@/components/form/form/components/form-api-select/accounting-event-list';
import request from '@/utils/request';
import { isEmpty } from 'lodash';
const ApiSelect = observer(({ value, type }) => {
    const { apiDataSource } = useLocalObservable(() => apiStore);
    const dataSourceStore = apiDataSource[type] || [];
    const [label, setLabel] = React.useState('');
    const fetchData = useCallback(async () => {
        const apiName = ApiMap[type];
        const setLabels = (content) => {
            const isIdList = idList.includes(type);
            const data = content?.map(({ name, code, id }) => {
                return {
                    label: `${name}(${code})`,
                    value: isIdList ? id : code,
                };
            });
            const labelRender = data.find(item => item.value === value)?.label;
            setLabel(labelRender);
        };
        if (type === 'DECISION_MAP_LIST') {
            const { content = [] } = await request.get(apiName, {
                params: { usageScenario: '902900000003' },
            });
            setLabels(content);
        }
        else if (type === 'ACCT_PARAM_ID_ITEM_LIST' || type === 'ACCT_PARAM_ID_ABSTRACT_LIST') {
            const paramCatType = type === 'ACCT_PARAM_ID_ITEM_LIST' ? 'item' : 'abstract';
            const { content = [] } = await request.get(apiName, {
                params: { paramCatType },
            });
            setLabels(content);
        }
        else {
            const { content = [] } = await request.get(apiName);
            setLabels(content);
        }
    }, [type, value]);
    useEffect(() => {
        if (!isEmpty(dataSourceStore)) {
            const labelRender = dataSourceStore?.find((item) => item?.value === value)?.label;
            setLabel(labelRender);
        }
        else {
            fetchData();
        }
    }, [dataSourceStore, fetchData, value]);
    return createElement("span", null, type === 'ENTITY_TREE' ? value : label);
});
export default ApiSelect;
